import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    requestAnimationFrame(() => {
      this.scrollToBottom()
    })

    document.addEventListener(
      "turbo:before-stream-render",
      this.beforeStreamRender
    )
  }

  disconnect() {
    document.removeEventListener(
      "turbo:before-stream-render",
      this.beforeStreamRender
    )
  }

  beforeStreamRender = (event) => {
    if (event.target.action !== "append") return
    if (event.target.target !== "messages") return

    const render = event.detail.render

    event.detail.render = () => {
      render(event.target)

      requestAnimationFrame(() => {
        this.scrollToBottom()
      })
    }
  }

  scrollToBottom() {
    this.containerTarget.scrollTop = this.containerTarget.scrollHeight
  }
}